import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Lb4ApiService } from 'src/app/shared/service/api/lb4-api.service';
import { DetailApplicationService } from '../../service/detail-application.service';

@Component({
  selector: 'app-send-orders',
  templateUrl: './send-orders.component.html',
  styleUrls: ['./send-orders.component.scss'],
})
export class SendOrdersComponent implements OnInit {
  @Input() civilEngineering: boolean;
  @Input() electromechanical: boolean;
  @Input() formid: string;
  activeTable = false;
  civilEngineeringSignData = [];
  electromechanicalSignData = [];
  signData = {
    civil: [],
    electro: []
  };
  status: string;
  projectData: string;
  projectTypeInfo = [];

  constructor(
    private lb4ApiService: Lb4ApiService,
    private detailApplicationService: DetailApplicationService,
    private message: NzMessageService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.detailApplicationService.civilOrElec.subscribe(res => {
      this.projectData = res;
      this.civilEngineering = this.projectData['civilEngineering'];
      this.electromechanical = this.projectData['electromechanical'];
      // 厂务课级签核时工程分类变更后重新初始化签核记录
      this.getInitSignOrder();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.projectTypeInfo = [];
    if (this.civilEngineering) {
      this.projectTypeInfo.push({ 'text': 'ApprovalHistoryInfo.CivilEngineering', 'value': 'civil' });
    }
    if (this.electromechanical) {
      this.projectTypeInfo.push({ 'text': 'ApprovalHistoryInfo.ElectromechanicalEngineering', 'value': 'electro' });
    }
    this.getInitSignOrder();
  }

  async getInitSignOrder() {
    const tempData = {
      civil: [],
      electro: []
    };
    await this.lb4ApiService.find('form_sign_process', {
      where: { formId: this.formid },
    }).then(res => {
      // 获取土建的签核记录:去掉签核第5步骤的机电(civilOrElectro=1)的厂商标单制定
      tempData.civil = res.filter(value => (value['civilOrElectro'] !== 1));
      // 获取机电的签核记录:去掉签核第5步骤的土建(civilOrElectro=0)的厂商标单制定
      tempData.electro = res.filter(value => (value['civilOrElectro'] !== 0));
    }).catch(e => {
      this.message.create('error', `${this.translateService.instant('CommonMessageTip.getDataFail')}`);
    })

    if (this.civilEngineering) {
      this.signData.civil = [].concat(tempData.civil);
    } else {
      this.signData.civil = [];
    }
    if (this.electromechanical) {
      this.signData.electro = [].concat(tempData.electro);
    } else {
      this.signData.electro = [];
    }
  }
}
